import styled, { css } from "styled-components";
import { StyledInputProps } from "./types";
import { ANIMATION, SPACING } from "../../../utils/constants";

export const InputWrapper = styled.div`
  width: 100%;
`;

export const InputFieldWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const titleVariantStyles = css<StyledInputProps>`
  border: none;
  border-bottom: 2px solid var(--input-title-underline, var(--color-primary));
  border-radius: 0;
  background: transparent;
  padding: ${SPACING.xs}px 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--input-title-size, var(--text-xxl));
  font-weight: 700;
  color: var(--input-title-color, var(--color-text-default));

  &:hover:not(:disabled):not(:focus) {
    border-color: var(--input-title-underline, var(--color-primary));
    background: transparent;
  }

  &:focus {
    outline: none;
    border-color: var(--input-title-underline, var(--color-primary));
    box-shadow: none;
    transform: none;
  }

  &::placeholder {
    color: var(--color-text-secondary);
    font-weight: 400;
    opacity: 1;
  }
`;

export const StyledInput = styled.input<StyledInputProps>`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid
    ${(props) =>
      props.$error ? "var(--color-error-border)" : "var(--color-gray-border)"};
  border-radius: 0.5rem;
  font-size: var(--text-base);
  color: var(--color-text-default);
  background: var(--color-card-background);
  transition: ${ANIMATION.transitions.all};

  /* Hover state for better interactivity */
  &:hover:not(:disabled):not(:focus) {
    border-color: ${(props) =>
      props.$error ? "var(--color-error-hover)" : "var(--color-primary)"};
    background: var(--hover-background);
  }

  /* Focus cue via border + shadow ring only. No scale transform: it grows the
     field past its box, which overflows / gets clipped on full-bleed layouts. */
  &:focus {
    outline: none;
    border-color: ${(props) =>
      props.$error ? "var(--color-error-border)" : "var(--color-primary)"};
    box-shadow: var(--shadow-focus);
  }

  /* Improved disabled state */
  &:disabled {
    color: var(--color-text-muted);
    background: var(--color-background-disabled);
    border-color: var(--color-border-light);
    cursor: not-allowed;
    opacity: 0.6;
  }

  /* Placeholder styling for theme awareness */
  &::placeholder {
    color: var(--color-text-muted);
    opacity: 0.35;
  }

  /* Readonly state styling */
  &:read-only {
    background: var(--color-background-disabled);
    cursor: default;
  }

  /* Title variant: large underlined heading-style input */
  ${(props) => props.$variant === "title" && titleVariantStyles}
  /* Reserve the clear control's width even in the full-width title variant. */
  ${(props) =>
    props.$hasClear &&
    css`
      padding-inline-end: ${SPACING.xl + SPACING.md}px;
    `}
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: ${SPACING.sm}px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  color: var(--color-error);
  font-size: var(--text-xs);
`;
